export const LINK_ACTION_LABELS = { url: 'Link URL', open: 'Open in a new tab' } as const
